<template>
  <component :is="component" v-bind="componentProps" @click="onClick">
    <slot :is-external="isExternal" />
  </component>
</template>

<script setup>
import { useRouter, useRoute, computed } from "#imports";
import { getUrlExtension } from "../../helpers/url";
const props = defineProps({
  to: { type: String, required: false },
  target: { type: String, required: false },
  isLink: { type: Boolean, required: false },
  activeClass: { type: String, required: false }
});
defineSlots();
const EXTERNAL_URL_EXTENSIONS = ["jpg", "png", "svg", "pdf"];
const router = useRouter();
const route = useRoute();
const href = computed(() => {
  if (!props.to) {
    return "";
  }
  if (props.to.startsWith("www")) {
    return `https://${props.to}`;
  }
  return props.to;
});
const component = computed(() => href.value ? "a" : "div");
const urlExtension = computed(() => getUrlExtension(href.value) || "");
const isExternal = computed(
  () => href.value.startsWith("http") || href.value.startsWith("mailto:") || href.value.startsWith("tel:") || EXTERNAL_URL_EXTENSIONS.includes(urlExtension.value)
);
const isActive = computed(
  () => route.path && href.value ? route.path.startsWith(href.value) : false
);
const componentProps = computed(() => {
  const componentProps2 = {
    class: []
  };
  if (href.value) {
    componentProps2.href = href.value;
    if (props.target) {
      componentProps2.target = props.target;
    } else if (isExternal.value) {
      componentProps2.target = "_blank";
    }
  }
  if (props.isLink) {
    componentProps2.class.push("link");
    componentProps2.class.push(isExternal.value ? "is-external" : "is-internal");
  }
  if (isActive.value) {
    componentProps2.class.push(props.activeClass || "nuxt-link-exact-active");
  }
  return componentProps2;
});
function onClick(e) {
  if (isExternal.value) {
    return;
  }
  e.preventDefault();
  router.push(href.value);
}
</script>
